import {TaskTemplateInputType} from "../enums";
import {DatasetIdentifierStr} from "../dataset/DatasetIdentifierStr";
import {ProductTemplateTaskSelectionOptions} from "../product-template/ProductTemplateTaskSelectionOptions";
import {IDatasetInputOutputPair} from "./task-template/TaskTemplateInfo";

export class TaskInputGroup {
    isGrouped: boolean = false;
    title?: string;

    constants: Record<string, string> = {};
    productTemplates: Record<string, ProductTemplateTaskSelectionOptions> = {};

    inputIndexedDatasets: Record<string, DatasetIdentifierStr[]> = {};
    inputNamedDatasets: Record<string, DatasetIdentifierStr> = {};
    inputNamedCategories: Record<string, number> = {};

    outputIndexedDatasets: Record<string, DatasetIdentifierStr[]> = {};
    outputNamedDatasets: Record<string, DatasetIdentifierStr> = {};
    outputNamedCategories: Record<string, number> = {};

    datasetInputOutputPairs: Record<string, IDatasetInputOutputPair> = {}

    freestyleJson: Record<string, any> = {};

    constructor(data?: Partial<TaskInputGroup>) {
        if (data) {
            Object.assign(this, data)
        }
    }

    static getValueLocation = (inputType: TaskTemplateInputType): (keyof TaskInputGroup | null) => {
        switch (inputType) {
            case TaskTemplateInputType.CONSTANT:
                return "constants" as keyof TaskInputGroup;
            case TaskTemplateInputType.PRODUCT_TEMPLATE:
                return "productTemplates" as keyof TaskInputGroup;
            case TaskTemplateInputType.DATASET_PAIRS:
                return "datasetInputOutputPairs" as keyof TaskInputGroup;

            case TaskTemplateInputType.INPUT_INDEXED_DATASETS:
                return "inputIndexedDatasets" as keyof TaskInputGroup;
            case TaskTemplateInputType.INPUT_NAMED_DATASET:
                return "inputNamedDatasets" as keyof TaskInputGroup;
            case TaskTemplateInputType.INPUT_NAMED_CATEGORY:
                return "inputNamedCategories" as keyof TaskInputGroup;

            case TaskTemplateInputType.OUTPUT_INDEXED_DATASETS:
                return "outputIndexedDatasets" as keyof TaskInputGroup;
            case TaskTemplateInputType.OUTPUT_NAMED_DATASET:
                return "outputNamedDatasets" as keyof TaskInputGroup;
            case TaskTemplateInputType.OUTPUT_NAMED_CATEGORY:
                return "outputNamedCategories" as keyof TaskInputGroup;

            case TaskTemplateInputType.FREESTYLE_JSON:
                return "freestyleJson" as keyof TaskInputGroup;

            default:
                return null;
        }
    }
}